import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';

const profileTimelineItemCss = ":host{position:relative;box-sizing:border-box}:host *,:host *:before,:host *:after{box-sizing:inherit}.timeline-item{display:flex;flex-direction:row;align-items:flex-start;column-gap:1rem;padding:1rem 1rem 1rem 2rem;border-radius:0.5rem;background-color:white}.timeline-item .stamp{min-width:1.5rem;width:1.5rem;height:1.5rem;min-height:1.5rem;display:grid;place-items:center;border-radius:0.25rem;font:var(--tt-font-medium);margin-top:0.25rem}.timeline-item .stamp ::slotted(tt-icon){font-size:1.25rem}.timeline-item .stamp:not([data-icon]),.timeline-item .stamp[data-icon=false]{background-color:var(--tt-color-green-400);color:var(--tt-color-white);border-radius:50%}.timeline-item .layout{display:flex}.timeline-item .layout[data-direction=horizontal]{column-gap:2rem}.timeline-item .layout[data-direction=horizontal],.timeline-item .layout[data-direction=horizontal] .content{flex-direction:row}.timeline-item .layout[data-direction=vertical]{row-gap:1rem}.timeline-item .layout[data-direction=vertical],.timeline-item .layout[data-direction=vertical] .content{flex-direction:column}.timeline-item .layout[data-direction=vertical] .content{padding-block:0.5rem}.timeline-item .layout .data{display:flex;align-items:flex-start;gap:0.5rem;max-width:22.5rem}.timeline-item .layout .data .thumbnail{width:4.5rem;height:2.5rem;overflow:hidden;margin-block:-0.25rem;flex-shrink:0}.timeline-item .layout .data .thumbnail ::slotted(img){display:block;object-fit:cover;height:100%;width:100%}.timeline-item .layout .data .thumbnail[data-empty]{display:none}.timeline-item .layout .data .info{display:flex;flex-direction:column;min-width:0}.timeline-item .layout .data .info .label{font:var(--tt-font-medium)}.timeline-item .layout .data .info .datetime{font:var(--tt-font-standard);color:var(--tt-color-gray-700)}.timeline-item .layout .data .info .label,.timeline-item .layout .data .info .datetime{overflow:hidden;white-space:nowrap;text-overflow:ellipsis;min-width:0}.timeline-item .layout .content{display:flex}";

const ProfileTimelineItem = /*@__PURE__*/ proxyCustomElement(class extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.hasStampIcon = false;
    this.hasThumbnail = false;
    this.label = undefined;
    this.datetime = undefined;
    this.direction = 'horizontal';
  }
  handleImageSlotChange(event) {
    const slot = event.target;
    this.hasThumbnail = slot.assignedElements().length > 0;
  }
  handleStampSlotChange(event) {
    var _a, _b;
    const slot = event.target;
    this.hasStampIcon = ((_b = (_a = slot.assignedElements()) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.tagName) === 'TT-ICON';
  }
  connectedCallback() {
    this.handleStampSlotChange = this.handleStampSlotChange.bind(this);
    this.handleImageSlotChange = this.handleImageSlotChange.bind(this);
  }
  render() {
    return (h("div", { class: "timeline-item", part: "base" }, h("div", { class: "stamp", "data-icon": this.hasStampIcon }, h("slot", { name: "stamp", onSlotchange: this.handleStampSlotChange })), h("div", { class: "layout", "data-direction": this.direction }, h("div", { class: "data" }, h("div", { class: "thumbnail", "data-empty": !this.hasThumbnail }, h("slot", { name: "thumbnail", onSlotchange: this.handleImageSlotChange })), h("div", { class: "info" }, h("div", { class: "label" }, h("slot", { name: "label" }, this.label)), h("div", { class: "datetime" }, h("slot", { name: "datetime" }, this.datetime)))), h("div", { class: "content" }, h("slot", null)))));
  }
  get element() { return this; }
  static get style() { return profileTimelineItemCss; }
}, [1, "tt-profile-timeline-item", {
    "label": [1],
    "datetime": [1],
    "direction": [1],
    "hasStampIcon": [32],
    "hasThumbnail": [32]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["tt-profile-timeline-item"];
  components.forEach(tagName => { switch (tagName) {
    case "tt-profile-timeline-item":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, ProfileTimelineItem);
      }
      break;
  } });
}

const TtProfileTimelineItem = ProfileTimelineItem;
const defineCustomElement = defineCustomElement$1;

export { TtProfileTimelineItem, defineCustomElement };
